import { render, staticRenderFns } from "./EstatePlanning.vue?vue&type=template&id=c9944190&"
import script from "./EstatePlanning.vue?vue&type=script&setup=true&lang=js&"
export * from "./EstatePlanning.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports